import { FC } from "react";
import styles from "./styles.module.css";

import { GradientButton } from "components/GradientButton";
import { Link } from "react-router-dom";
import { routesEnum } from "pages/Routes";

const HostHKTBanner: FC = () => {
  return (
    <div className={styles.root}>
      <div className="container-lg">
        <div className={styles.content}>
          <img src="/images/hackathon/dollar-dollar-color.png" alt="dollar" />
          <h3>Want to host an exclusive hackathon on CrowdHack?</h3>
          <Link to={routesEnum.contact}>
            <GradientButton>Get In Touch</GradientButton>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HostHKTBanner;
